import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CustomerAgingOpenInvoicesPrintRequest,
  CustomerCurrentAgingMailRequest,
  CustomerPaymentAgingHistoryCriteriaBean,
  CustomerPaymentCurrentAgingHistoryRequest,
  CustomerSearchCriteria,
  MailInfoBean,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
  InvoiceSearchCriteria
} from "../ds/ds.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
  ColumnDefinition,
} from "../gui_components/UIComponents.js";

import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCreditMemoModule,
  PopupInvoiceModule,
    PopupARModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js"
import CustomTable from "../gui_components/CustomTable.js";
class CustomerAging extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer Current Aging Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      isShowMailButton: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new CustomerPaymentAgingHistoryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowCreditMemoModule: false,
      moduleForPopup: [],
      inquiryData: null,
      agingBucketList: [],
      invoiceList: [],
      creditMemoList: [],
      salesPersons: [],
      mailInfoBean: new MailInfoBean(),
      isShowMailPopup: false,
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      isShowCriteriaView: true,
      isDisableFields: false,
      chargeBackList: [],
      isShowInvoiceDuePopup:false,
          isShowInvoiceData: false,
          unPostedArList:[],
        unpostedCriteria :  new InvoiceSearchCriteria (),
        overAllUnpostedArList:[],
          isShowARModule: false,
    };
    this.customerCodeRef = React.createRef();
    this.totalDue = 0;
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let salesPersons = attribute_cache.salesPersons;
    if (salesPersons != null || salesPersons != undefined) {
      salesPersons.map((attr) => {
        this.state.salesPersons.push(attr);
      });
    }
    this.initLookupHandlers();
    if (
      this.props.customerCode !== "" &&
      this.props.customerCode !== undefined
    ) {
      let temp_Criteria = this.state.criteria;
      temp_Criteria.customerCode = this.props.customerCode;
      this.setState({
        criteria: temp_Criteria,
        isShowCriteriaView: false,
        isShowResetButton: false,
        isShowExecuteButton: false,
        isShowClearCriteriaButton: false,
      });
      this.loadPage(1);
    }
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.state.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
  };
  componentDidUpdate() {
    this.totalDue = 0;
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
    loadCustomerUnpostedInquiryList = (criteria) => {
      console.log("criteria..",criteria);
    if (SecurityAccessManager.CustomerCurrentAgingInquiry_IsAccessible()) {
      AccountReceivableService.getUnPostedARDetails(
        criteria,
        this.customerUnPostedPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  customerUnPostedPageResponse = (response)=>{
    console.log("response..",response);
    if (response.data != null && response.data.resultBean != null) {
            let unPostedList = response.data.resultBean.unpostedAr;
            if (unPostedList != null || !isEmptyArray(unPostedList)) {
              this.setState({
                overAllUnpostedArList: unPostedList,
      
                //isShowUnPostedARPopup: true,
              });
            }
          }
  }
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let unpostedCriteria = this.state.unpostedCriteria;
    unpostedCriteria.companyCode = this.companyCode;
		unpostedCriteria.customerCode = criteria.customerCode;

    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading...",
    });
    if (!isEmptyString(criteria.customerCode)) {
      this.loadCustomerAgingInquiryList(criteria);
        // this.loadCustomerUnpostedInquiryList(criteria);
    } else {
      let errMsg = "Customer Code Required";
      let errorList = [];
      errorList.push(errMsg);
      this.setState({
        alertMessage: errorList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadCustomerAgingInquiryList = (criteria) => {
    if (SecurityAccessManager.CustomerCurrentAgingInquiry_IsAccessible()) {
      ReportService.inquireCustomerPaymentCurrentAgingHistory(
        criteria,
        this.customerAgingInquiryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  customerAgingInquiryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let inquiryDataList = response.data.result;
      if (inquiryDataList != null) {
        let agingBucketList = [];
        const bucketGroup = response.data.result.agingBucketGroupBean;
        if (bucketGroup != null) {
          if (!isEmpty(bucketGroup.buckets)) {
            agingBucketList = response.data.result.agingBucketGroupBean.buckets;
          }
        }
        const agingHistory = response.data.result.agingHistoryBean;
        if (agingHistory != null) {
          if (agingHistory.invoiceDetails != null) {
            let invoiceList = agingHistory.invoiceDetails;
    
            invoiceList.map((ln) => {
              parseFloat(ln.invoiceDueAmount).toFixed(2);
              parseFloat(ln.invoiceAmount).toFixed(2);
            });
            this.setState({ invoiceList: invoiceList });
          }
          if (agingHistory.creditMemoDetails != null) {
            let creditMemoList = agingHistory.creditMemoDetails;
            this.setState({ creditMemoList: creditMemoList });
          }

          this.setState({
            isInquiryDatasFound: true,
            isShowResetButton: true,
            inquiryData: agingHistory,
            agingBucketList: agingBucketList,
            isShowPDFButton: true,
            isShowExcelButton: true,
            isShowMailButton: true,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
            isShowClearCriteriaButton: false,
          });
          this.disable();
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new CustomerPaymentAgingHistoryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.salesPersonName = "";
    this.setState({
      criteria: criteria,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let criteria = new CustomerPaymentAgingHistoryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.salesPersonName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowMailButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      inquiryData: null,
      agingBucketList: new Array(),
      invoiceList: new Array(),
      creditMemoList: new Array(),
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.historyDate = currentDate;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CustomerPaymentCurrentAgingHistoryRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CustomerCurrentAgingInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateCustomerPaymentCurrentAgingHistoryReport(
          listRequest,
          this.generateCustomerAgingPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CustomerCurrentAgingInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCustomerPaymentCurrentAgingHistoryReport(
          listRequest,
          this.generateCustomerAgingPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCustomerAgingPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateCustomerAgingPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  mailOnChange = (e) => {
    let mailInfoBean = this.state.mailInfoBean;
    mailInfoBean[e.target.name] = e.target.value;
    this.setState({ mailInfoBean: mailInfoBean });
  };
  createMail = (e) => {
    if (e.detail === 1) {
      this.setState({ isShowMailPopup: true });
      let criteria = this.state.criteria;
      let request = new CustomerCurrentAgingMailRequest();
      request.criteria = criteria;
      if (
        SecurityAccessManager.CustomerCurrentAgingInquirySendMailReport_IsAccessible()
      ) {
        ReportService.fetchCustomerCurrentAgingMailDefaultInfoBean(
          criteria,
          this.fetchMailResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(4);
      }
    }
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  fetchMailResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null) {
      let mailInfo = response.data.mailDefaultInfo;
      if (mailInfo != null) {
        this.setState({ mailInfoBean: mailInfo });
      }
    }
  };
  sendMail = (e) => {
    if (e.detail === 1) {
      this.clearError();
      let mailInfoBean = this.state.mailInfoBean;
      let criteria = this.state.criteria;
      let reportBean = new RestReportBean();
      let request = new CustomerCurrentAgingMailRequest();
      request.criteria = criteria;
      request.infoBean = mailInfoBean;
      request.reportBean = reportBean;
      if (
        SecurityAccessManager.CustomerCurrentAgingInquirySendMailReport_IsAccessible()
      ) {
        ReportService.sendCustomerCurrentAgingMail(
          request,
          this.sendMailResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(4);
      }
    }
  };
  sendMailResponse = (response) => {
    if (response.data.success) {
      this.showInfoMessage(response.data);
    } else {
      this.showErrorMessage(response.data);
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowMailPopup: isShowPopup,
      isShowInvoiceDuePopup:isShowPopup,
          isShowInvoiceData: false,
          unPostedArList:[],
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCreditMemoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCreditMemoModule: true,
          moduleForPopup: (
            <PopupCreditMemoModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowCreditMemoModule: isOpen,
        isShowARModule: isOpen,
      moduleForPopup: [],
    });
  };
  openInvoiceReport = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;
    let listRequest = new CustomerAgingOpenInvoicesPrintRequest();
    listRequest.companyCode = this.companyCode;
    listRequest.customerCode = criteria.customerCode;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (
      SecurityAccessManager.CustomerCurrentAgingInquiryPDFReport_IsAccessible()
    ) {
      ReportService.generateCustomerAgingOpenInvoicesPrintReport(
        listRequest,
        this.generateOpenInvoiceCustomerAgingPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(2);
    }
  };
  generateOpenInvoiceCustomerAgingPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  onModuleExit = () => {
    this.props.onModuleExit();
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      criteria.salesPersonName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      temp_criteria.salesPersonName = salesPersonBean.description;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ salesPersonList: salesPersonBean });
  };
  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };
  runningInvoiceTotalDue = (due) => {
    let totalDue = 0;
    totalDue = this.totalDue;
    if (due != null && due != undefined) {
      totalDue = parseFloat(totalDue) + parseFloat(due);
      totalDue = parseFloat(totalDue).toFixed(2);
      this.totalDue = totalDue;
    }
    return totalDue;
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPersonName", "salesPersonNames", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceAmt", "invoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DueDate", "invoicePaymentDueDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DueAmount", "invoiceDueAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total Due", "invoiceDueAmount", true)
        .setStatusDetails(true, this.runningInvoiceTotalDue)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
        columns.push(
          new ColumnDefinition()
            .setDetails("ProvPaid", "invoiceProvisionalPaidAmount", true, true)
            .setStyleDetails("right", "", "", "wt-2", "wt-2")
            //.setSubHeaderDetails(true, "allCustomerProvisionalAppliedAmount")
            
            .setClickDetails(true, false, this.viewCustomerProvisionalPopup, null)
        );
    return columns;
  };

    viewCustomerProvisionalPopup = (e, val, rowData)=>{
  
      
       if (e.detail === 1) {
        this.loadProvisionalDetailList(rowData.invoiceNumber);
        this.setState({
          invoiceData: rowData,
          isShowInvoiceData: true,
          isShowInvoiceDuePopup: true,
        });
      }
    }
   loadProvisionalDetailList = (code) => {
      let criteriaBean = new RestReadRequest();
      criteriaBean.companyCode = this.companyCode;
      criteriaBean.code = code;
  
      if (SecurityAccessManager.CustomerCurrentAgingInquiry_IsAccessible()) {
        AccountReceivableService.getUnPostedARDetailsForInvoices(
          criteriaBean,
          this.loadInvoiceDetailResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    };
    loadInvoiceDetailResponse = (response)=>{
       if (response.data != null && response.data.resultBean != null) {
            let unPostedList = response.data.resultBean.unpostedAr;
            if (unPostedList != null || !isEmptyArray(unPostedList)) {
              this.setState({
                unPostedArList: unPostedList,
      
                //isShowUnPostedARPopup: true,
              });
            }
          }
    }
  creditMemoColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "creditMemoDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemo#", "creditMemoNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCreditMemoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenAmt", "creditMemoTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  chargeBackListColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ChargeBack#", "", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenAmt", "", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  toPaymentType = (type) => {
    let finalType = " ";
    if (type == 1) finalType = "Check";
    else if (type == 2) finalType = "CreditMemo";
    else if (type == 3) finalType = "CreditCard";
    else if (type == 4) finalType = "DebitCard";
    else if (type == 5) finalType = "Cash";
    else if (type == 6) finalType = "ChargeBack";
    else if (type == 8) finalType = "Wire Transfer";
    else if (type == 9) finalType = "Ach";

    return finalType;
  };

  toPaymentStatus = (applied) => {
    let finalType = "UnPosted";
    if (applied) finalType = "Posted";

    return finalType;
  };
    openInvoicesDetailColumns = () => {
      const columns = new Array();
    
      columns.push(
        new ColumnDefinition()
          .setDetails("AR#", "accountReceivableNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
          .setClickDetails(true, false, this.viewARModule, null)
      );
        columns.push(
        new ColumnDefinition()
          .setDetails("Date", "accountReceivableDate", true,false,true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Type", "paymentType", true)
  
          .setStyleDetails("left", "10", "", "wt-3", "wt-3")
               .setStatusDetails(true, this.toPaymentType)
          //.getStatusCaption("",this.toPaymentType)
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Document", "documentNumber", true)
  
          .setStyleDetails("left", "10", "", "wt-3", "wt-3")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Applied Amount", "paymentAmount", true, true)
          .setStyleDetails("right", "", "", "wt-2", "wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Currency", "currencyCode", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
              columns.push(
        new ColumnDefinition()
          .setDetails("PaymentDate", "paymentDate", true,false,true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
              columns.push(
        new ColumnDefinition()
          .setDetails("PostDate", "paymentPostDate", true,false,true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
            columns.push(
        new ColumnDefinition()
          .setDetails("Status", "isApplied", true)
  
          .setStyleDetails("left", "10", "", "wt-3", "wt-3")
             .setStatusDetails(true, this.toPaymentStatus)
         // .getStatusCaption("",this.toPaymentStatus)
      );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails("DueAmt", "invoiceDueAmount", true, true)
      //     .setStyleDetails("right", "", "", "wt-2", "wt-2")
      // );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails("ProvPaid", "invoiceProvisionalPaidAmount", true, true)
      //     .setStyleDetails("right", "", "", "wt-2", "wt-2")
      // );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails("TotalDue", "invoiceDueAmount", true, true)
      //     .setStyleDetails("right", "", "", "wt-2", "wt-2")
      // );
      return columns;
    };


     UnpostedArMemoColumns = () => {
      const columns = new Array();
    
      columns.push(
        new ColumnDefinition()
          .setDetails("AR#", "accountReceivableNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
          .setClickDetails(true, false, this.viewARModule, null)
      );
        columns.push(
        new ColumnDefinition()
          .setDetails("Date", "accountReceivableDate", true,false,true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
          columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
      columns.push(
        new ColumnDefinition()
          .setDetails("Type", "paymentType", true)
  
          .setStyleDetails("left", "10", "", "wt-3", "wt-3")
               .setStatusDetails(true, this.toPaymentType)
          //.getStatusCaption("",this.toPaymentType)
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Document", "documentNumber", true)
  
          .setStyleDetails("left", "10", "", "wt-3", "wt-3")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Applied Amount", "paymentAmount", true, true)
          .setStyleDetails("right", "", "", "wt-2", "wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Currency", "currencyCode", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
              columns.push(
        new ColumnDefinition()
          .setDetails("PaymentDate", "paymentDate", true,false,true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
              columns.push(
        new ColumnDefinition()
          .setDetails("PostDate", "paymentPostDate", true,false,true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
            columns.push(
        new ColumnDefinition()
          .setDetails("Status", "isApplied", true)
  
          .setStyleDetails("left", "10", "", "wt-3", "wt-3")
             .setStatusDetails(true, this.toPaymentStatus)
         // .getStatusCaption("",this.toPaymentStatus)
      );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails("DueAmt", "invoiceDueAmount", true, true)
      //     .setStyleDetails("right", "", "", "wt-2", "wt-2")
      // );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails("ProvPaid", "invoiceProvisionalPaidAmount", true, true)
      //     .setStyleDetails("right", "", "", "wt-2", "wt-2")
      // );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails("TotalDue", "invoiceDueAmount", true, true)
      //     .setStyleDetails("right", "", "", "wt-2", "wt-2")
      // );
      return columns;
    };
  
    viewARModule = (e, code, rowData) => {
        if (e.detail === 1) {
          if (code !== "" && code !== undefined) {
            this.setState({
              isShowARModule: true,
              moduleForPopup: (
                <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
              ),
            });
          }
        }
      };
  render() {
    let inquiryData = this.state.inquiryData;
    let agingBucketList = this.state.agingBucketList;
    let invoiceList = this.state.invoiceList;
    let creditMemoList = this.state.creditMemoList;
    let chargeBackList = this.state.chargeBackList;

        let invoiceData = this.state.invoiceData;
    let unPostedArList = this.state.unPostedArList;
    let overAllUnpostedArList = this.state.overAllUnpostedArList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          extend_toolbar={
            <>
              {this.state.isShowMailButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.createMail(e)}
                >
                  Mail
                </Button>
              )}
            </>
          }
        />
        {this.state.isShowCriteriaView ? (
          <CriteriaView
            {...this.state}
            loadPage={this.loadPage}
            onChange={this.onChange}
            customerLookupHandler={this.state.customerLookupHandler}
            salesPersonLookupHandler={this.state.salesPersonLookupHandler}
            openInvoiceReport={this.openInvoiceReport}
            customerCodeOnChange={this.customerCodeOnChange}
            customerCodeRef={this.customerCodeRef}
            customerCodeEnterKeyEventHandler={
              this.customerCodeEnterKeyEventHandler
            }
            displayAutoCompleteList={this.displayAutoCompleteList}
            salesPersonEnterKeyEventHandler={
              this.salesPersonEnterKeyEventHandler
            }
            displayAutoCompleteSalesPersonList={
              this.displayAutoCompleteSalesPersonList
            }
            salesPersonCodeOnChange={this.salesPersonCodeOnChange}
          />
        ) : null}

                    <MultiViewPopup
                      isModulePopup={false}
                      isShowPopup={this.state.isShowInvoiceDuePopup}
                      closeOnEsc={false}
                      popupLvlClass={"popupSizeLevel2"}
                      closeAlertModalCallBack={this.closeAlertModalCallBack}
                      title={"Open Invoices"}
                      closeOnDocumentClick={false}
                      lineFunctionalityForm={this.lineFunctionalityForm}
                      headerButtonContainer={
                        <div className="floatLeft">
                          {/* {this.state.isShowInvoiceData && (
                            <div>
                              <Button
                                className="header_buttons enterFocus"
                                size="sm"
                                onClick={(e) => this.generateInvoicePdfReport(e)}
                              >
                                PDF
                              </Button>
        
                              <Button
                                className="header_buttons enterFocus"
                                size="sm"
                                onClick={(e) => this.generateInvoiceExcelReport(e)}
                              >
                                EXCEL
                              </Button>
                            </div>
                          )} */}
                        </div>
                      }
                      content={
                        <div className="">
                          {this.state.isShowInvoiceData && (
                            <div>
                              <Row>
                                <Col sm="1">
                                  <FormLabel>CompanyCode</FormLabel>
                                </Col>
                                <Col sm="2">
                                  <InputTextbox
                                    value={invoiceData.companyCode}
                                    disabled={true}
                                  />{" "}
                                </Col>
        
                                <Col sm="1">
                                  <FormLabel>CustomerCode</FormLabel>
                                </Col>
                                <Col sm="2">
                                  <InputTextbox
                                    value={invoiceData.customerCode}
                                    disabled={true}
                                  />{" "}
                                </Col>
        
                                <Col sm="5">
                                  <InputTextbox
                                    value={invoiceData.customerName}
                                    disabled={true}
                                  />{" "}
                                </Col>
                              </Row>
        
                              <Row>
                                <Col sm="1">
                                  <FormLabel>CurrencyCode</FormLabel>
                                </Col>
                                <Col sm="2">
                                  <InputTextbox
                                    value={invoiceData.currencyCode}
                                    disabled={true}
                                  />{" "}
                                </Col>
        
                                {/* <Col sm="1">
                                  {" "}
                                  <FormLabel>Total Due</FormLabel>
                                </Col>
                                <Col className="summary_text_box" sm="2">
                                  <InputTextbox
                                    value={toCommaSeperatedAmount(
                                      invoiceData.totalInvoiceDueAmount
                                    )}
                                    className="summary_input text-right"
                                    disabled={true}
                                  />
                                </Col> */}
                              </Row>
                              <div>
                                <div className="mt-3">
                                  <CustomTable
                                    data={unPostedArList}
                                    columns={this.openInvoicesDetailColumns()}
                                    label={"Detail List"}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      }
                    />

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowMailPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          popupLvlClass={"popupSizeLevel0"}
          title={"Mail Customer Current Aging"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.sendMail(e)}
              >
                Send
              </Button>
            </div>
          }
          content={
            <GenerateMailPopup
              {...this.state}
              mailOnChange={(e) => this.mailOnChange(e)}
            />
          }
        />

        {this.state.isInquiryDatasFound && (
          <div>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Currency</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <InputTextbox
                  value={inquiryData.currencyCode}
                  className="summary_input"
                  disabled={true}
                />
              </Col>

              <Col sm="1">
                {" "}
                <FormLabel>TotalDue</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <NumberFormatInputbox
                  value={inquiryData.totalInvoiceDueAmount}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                  onchange={this.onChange}
                />
              </Col>

              <Col sm="1">
                {" "}
                <FormLabel>UnAppliedCredit [CreditMemo]</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <NumberFormatInputbox
                  value={inquiryData.totalUnAppliedCreditMemoAmount}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                  onchange={this.onChange}
                />
              </Col>

              <Col sm="1">
                {" "}
                <FormLabel>UnAppliedCredit [ChargeBack]</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <NumberFormatInputbox
                  value={inquiryData.totalUnAppliedChargeBackAmount}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                  onchange={this.onChange}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <Table id="fabrics_tables">
                  <thead>
                    {agingBucketList.map((list, index) => (
                      <th>{list.code}</th>
                    ))}
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {toCommaSeperatedAmount(
                          inquiryData.standardCurrentAgeAmount
                        )}
                      </td>
                      <td>{toCommaSeperatedAmount(inquiryData.ageAmount1)}</td>
                      <td>{toCommaSeperatedAmount(inquiryData.ageAmount2)}</td>
                      <td>{toCommaSeperatedAmount(inquiryData.ageAmount3)}</td>
                      <td>{toCommaSeperatedAmount(inquiryData.ageAmount4)}</td>
                    </tr>
                  </tbody>
                </Table>{" "}
              </Col>
            </Row>
            <div className="div_inline">
              <div className="div_Equal_no_height">
                <div className="mt-3">
                  <CustomTable
                    data={invoiceList}
                    columns={this.inquiryColumns()}
                    label = {"Aging Invoices"}
                  />
                </div>
              </div>
              <div className="div_Equal_no_height">
                <div className="mt-3">
                  <CustomTable
                    data={creditMemoList}
                    columns={this.creditMemoColumns()}
                      label = {"CreditMemo List"}
                  />
                </div>
                 <div className="mt-3">
                  <CustomTable
                    data={overAllUnpostedArList}
                    columns={this.UnpostedArMemoColumns()}
                     label = {"UnPosted AR List"}
                  />
                </div>
                <div className="mt-3">
                  <CustomTable
                    data={chargeBackList}
                    columns={this.chargeBackListColumns()}
                       label = {"chargeBack List"}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
         <MultiViewPopup
                  isModulePopup={true}
                  id="modulePopup"
                  popupLvlClass={"popupSizeLevel0"}
                  isShowPopup={this.state.isShowARModule}
                  closeModalCallBack={this.closeModalCallBack}
                  module={this.state.moduleForPopup}
                ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  let criteria = props.criteria;
  let isDisableFields = props.isDisableFields;
  let customerLookupHandler = props.customerLookupHandler;
  let salesPersonLookupHandler = props.salesPersonLookupHandler;
  let salesPersonCodeRef = React.createRef();
  const customerCodeRef = props.customerCodeRef;
  let isInquiryDatasFound = props.isInquiryDatasFound;
  const openInvoiceReport = (e) => {
    if (e.detail === 1) props.openInvoiceReport(e);
  };
  const salesPersonCodeOnChange = (e) => props.salesPersonCodeOnChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const salesPersonEnterKeyEventHandler = (e) => {
    props.salesPersonEnterKeyEventHandler(e);
  };
  const displayAutoCompleteSalesPersonList = () => {
    props.displayAutoCompleteSalesPersonList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>CustomerCode</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={true}
            lookupHandler={customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        {props.isInquiryDatasFound != true && (
          <Col sm="1">
            <FormLabel>SalesPerson</FormLabel>
          </Col>
        )}
        {props.isInquiryDatasFound != true && (
          <Col sm="2">
            <InputTextbox
              ref={salesPersonCodeRef}
              name="salesPersonCode"
              onChange={salesPersonCodeOnChange}
              value={criteria.salesPersonCode}
              lookupRequired={true}
              lookupHandler={salesPersonLookupHandler}
              enterKeyEventHandler={salesPersonEnterKeyEventHandler}
              autoCompleteListData={
                props.salesPersonPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteSalesPersonList}
              showAutoCompleteList={props.showAutoCompleteSalesPersonList}
            />
          </Col>
        )}
        {props.isInquiryDatasFound != true && (
          <Col sm="2">
            <InputTextbox
              name="salesPersonName"
              onChange={onChange}
              value={criteria.salesPersonName}
              disabled={true}
            />
          </Col>
        )}
        {isInquiryDatasFound && (
          <Col sm="2">
            <Button
              className="header_buttons"
              size="sm"
              onClick={(e) => openInvoiceReport(e)}
            >
              {" "}
              Open Invoice{" "}
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
}
class GenerateMailPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  mailOnChange = (e) => {
    this.props.mailOnChange(e);
  };
  render() {
    let mailInfoBean = this.props.mailInfoBean;
    return (
      <div>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>From</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox value={mailInfoBean.from} disabled={true} />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>To</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="tos"
              value={mailInfoBean.tos}
              onChange={this.mailOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>CCs</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="ccs"
              value={mailInfoBean.ccs}
              onChange={this.mailOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>BCCs</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="bccs"
              value={mailInfoBean.bccs}
              onChange={this.mailOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>Title</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="title"
              value={mailInfoBean.title}
              onChange={this.mailOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>Attachments</FormLabel>
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="6">
            <textarea
              rows={15}
              cols={72}
              name="message"
              value={mailInfoBean.message}
              onChange={this.mailOnChange}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
function CustomerCurrentAgingInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerAging {...props} name="" /> <br />
    </div>
  );
}
export default CustomerCurrentAgingInquiry;
